import styles from '../StepLayout.module.css';
import { StepLayout } from '../StepLayout';
import { AnimatedWordExample } from '../AnimatedWordExample';
import { TUTORIAL_LETTERS } from '../constants';
import { ru } from '@/i18n/ru';

export function Step2Order() {
  return (
    <StepLayout title={ru.onboarding.step2.title}>
      <p>{ru.onboarding.step2.body}</p>
      <div className={styles.examples}>
        <AnimatedWordExample word="компот" letters={TUTORIAL_LETTERS} showScore={false} />
        <AnimatedWordExample word="ток" letters={TUTORIAL_LETTERS} invalidReason={ru.onboarding.step2.reasonWrongOrder} />
        <AnimatedWordExample word="кот" letters={TUTORIAL_LETTERS} invalidReason={ru.onboarding.step2.reasonTooShort} />
      </div>
    </StepLayout>
  );
}
